var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "div",
    },
    [
      _c("div", { staticClass: "div-content" }, [
        _c(
          "div",
          { staticClass: "wh100", staticStyle: { overflow: "auto" } },
          [
            _c(
              "el-card",
              { staticClass: "content-list", attrs: { header: "维修分析" } },
              [
                _c(
                  "div",
                  { staticStyle: { width: "50%", "margin-left": "25%" } },
                  [
                    _c(
                      "div",
                      { staticClass: "search-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("日期范围:"),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "flex1",
                          attrs: {
                            type: "monthrange",
                            "range-separator": "至",
                            clearable: false,
                            "value-format": "yyyyMM",
                            "start-placeholder": "开始月份",
                            "end-placeholder": "结束月份",
                          },
                          model: {
                            value: _vm.searchData.YearMonth,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchData, "YearMonth", $$v)
                            },
                            expression: "searchData.YearMonth",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "search-item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("位置范围: "),
                        ]),
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "flex1",
                            on: { change: _vm.BuildingChange },
                            model: {
                              value: _vm.searchData.BuildingId,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchData, "BuildingId", $$v)
                              },
                              expression: "searchData.BuildingId",
                            },
                          },
                          _vm._l(_vm.BuildingList, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.Id,
                                staticClass: "search-checkbox",
                                attrs: { label: item.Id },
                              },
                              [_vm._v(" " + _vm._s(item.Name) + " ")]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "search-item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("类型范围: "),
                        ]),
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "flex1",
                            on: { change: _vm.DeviceTypeChange },
                            model: {
                              value: _vm.searchData.DeviceType,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchData, "DeviceType", $$v)
                              },
                              expression: "searchData.DeviceType",
                            },
                          },
                          _vm._l(_vm.DeviceTypeList, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.Id,
                                staticClass: "search-checkbox",
                                attrs: { label: item.Id },
                              },
                              [_vm._v(" " + _vm._s(item.DicName) + " ")]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "search-item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("分析内容: "),
                        ]),
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "flex1 content-selector",
                            model: {
                              value: _vm.selectedContents,
                              callback: function ($$v) {
                                _vm.selectedContents = $$v
                              },
                              expression: "selectedContents",
                            },
                          },
                          _vm._l(_vm.dataInfo.Content, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.Id,
                                staticClass: "content-checkbox",
                                attrs: { label: item.Id },
                              },
                              [_vm._v(" " + _vm._s(item.Name) + " ")]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "search-item" },
                      [
                        _c("span", { staticClass: "label" }),
                        _c(
                          "el-button",
                          {
                            staticClass: "flex1",
                            staticStyle: {
                              width: "300px",
                              "line-height": "40px",
                              "font-size": "16px",
                            },
                            attrs: { type: "primary" },
                            on: { click: _vm.openInfo },
                          },
                          [_vm._v("开始分析")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("AiWorkInfo", { ref: "AiWorkInfo" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }